import { EMPTY_LIST } from '../../../constants/common'
import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'
import { PROFILE_ROUTE_NAMES } from '../../../constants/route'
import { useInitData } from '../../../hooks'
import { MultipleViewTypeListActiveItemPreviewHeaderActions } from '../../MultipleViewTypeList'
import { getEmailProfileWidgetsInfo, getEmailThreadProfile } from '../Email.api'
import { EMAIL_PROFILE_WIDGET_NAME_FILES } from '../Email.constants'
import { EmailMessageProfile } from '../EmailMessageProfile'
import { EmailProfileAISummaryWidget } from '../EmailProfileWidget'
import { EmailThreadProfile } from '../EmailThreadProfile'

import * as styles from './EmailMultipleViewTypeListLayoutActiveItemPreview.module.css'

function EmailMultipleViewTypeListLayoutActiveItemPreview({
  actionsContextProps,
  activeItem,
  className = styles.EmailMultipleViewTypeListLayoutActiveItemPreview,
  profileLoadersRef,
  singleEmailAccount,
  onClosePreview,
  onReload,
  onSuccessRead,
}) {
  const { ai_features: aiFeatures } = useInitData()

  // should load files directly here cause preview is not using widget data
  async function getEmailThreadProfileDataWithFiles({ uuid, ...restParams }) {
    return Promise.all([
      getEmailThreadProfile({ uuid, ...restParams }),
      getEmailProfileWidgetsInfo({
        [FILTER_NAME_SUB_MENU]: restParams.params.sub_menu,
        email_thread_uuid: uuid,
        widget_name: EMAIL_PROFILE_WIDGET_NAME_FILES,
      }),
    ]).then(([threadRes, filesRes]) => ({
      data: {
        ...threadRes.data,
        files: filesRes?.data?.files.items || EMPTY_LIST,
      },
    }))
  }

  const Component = singleEmailAccount
    ? EmailMessageProfile
    : EmailThreadProfile

  return (
    <Component
      {...(singleEmailAccount
        ? null
        : { getProfileData: getEmailThreadProfileDataWithFiles })}
      actionsContextProps={actionsContextProps}
      className={className}
      headerProps={{
        Actions: MultipleViewTypeListActiveItemPreviewHeaderActions,
        AISummary: aiFeatures?.email_summary_generation
          ? EmailProfileAISummaryWidget
          : null,
        BackButton: null,
        actionsProps: {
          closeButtonProps: {
            className: styles.previewHeaderButton,
          },
          getProfileLink: singleEmailAccount
            ? PROFILE_ROUTE_NAMES.emailMessage
            : PROFILE_ROUTE_NAMES.emailThreadNG,
          id: activeItem,
          openInNewTabButtonProps: {
            className: styles.previewHeaderButton,
          },
          onClosePreview,
        },
        aiSummaryProps: {
          className: styles.aiSummaryWidget,
          contentContainerProps: {
            className: styles.aiSummaryContent,
          },
          initiallyExpanded: false,
          loadButtonProps: {
            className: styles.aiSummaryLoadButton,
          },
        },
      }}
      layoutProps={{ Footer: null }}
      mailUuid={activeItem}
      profileLoadersRef={profileLoadersRef}
      withWidgets={false}
      onReload={onReload}
      onSuccessRead={onSuccessRead}
    />
  )
}

export default EmailMultipleViewTypeListLayoutActiveItemPreview
